import { Component, Inject, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FileUploadValidators } from '@iplab/ngx-file-upload';
import { ToastrService } from 'ngx-toastr';
import { AdminService } from 'src/app/admin/admin.service';
import { LoaderService } from 'src/app/utils/loader.service';
interface DialogData {
  batchId: string | number;
  partName?:string
}
@Component({
  selector: 'app-update-batch-timeline',
  templateUrl: './update-batch-timeline.component.html',
  styleUrls: ['./update-batch-timeline.component.scss']
})
export class UpdateBatchTimelineComponent implements OnInit {
  demoForm: FormGroup;
  stage_file: any;
  fileUploaded: boolean;
  image_url: string | ArrayBuffer;
  revised_deadline: any;
  batchDetails: any = {
    id: null,
    dispatch_quantity: '',
    dispatch_date: "",
    timeline_flag: "",
    current_stage: {
      name: "Not available"
    },
    created_at: "",
    updated_at: "",
    is_active: true,
    next_stages: [{
      name: "Not available"
    }],
  };

  constructor(
    public dialogref: MatDialogRef<UpdateBatchTimelineComponent>,
    private dialog: MatDialog,
    private loaderService: LoaderService,
    private adminService: AdminService,
    private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private formBuilder: FormBuilder
  ) {
  }

  ngOnInit(): void {
    this.demoForm = this.formBuilder.group({
      timeline_flag: new FormControl('', [Validators.required]),
      affected_deadline: new FormControl(),
      reason_for_delay: new FormControl(),
      revised_deadline: new FormControl()
    }, { validators: this.customValidators });
    this.batchDetails.id = this.data.batchId || 1;
    this.batchDetails.part_name = this.data?.partName
    this.fetchBatch();
  }

  customValidators(formGroup: FormGroup):any {
    const timelineFlag = formGroup.get('timeline_flag').value;
    const affectedDeadline = formGroup.get('affected_deadline').value;

    if (timelineFlag === 'expecting-delay' || timelineFlag === 'delayed') {
      formGroup.get('reason_for_delay').setValidators([Validators.required]);
    } else {
      formGroup.get('reason_for_delay').clearValidators();
    }

    if (affectedDeadline === 'yes') {
      formGroup.get('revised_deadline').setValidators([Validators.required]);
    } else {
      formGroup.get('revised_deadline').clearValidators();
    }
  }

  close(sucess?:boolean) {
    this.dialogref.close(sucess);
  }

  fetchBatch() {
    this.adminService.fetchVendorOrderItemBatch(this.batchDetails.id).subscribe(
      (res:any) => {
        this.batchDetails = res?.body;
        this.batchDetails.part_name = this.data?.partName
        this.demoForm.patchValue({
        "timeline_flag" : this.batchDetails?.timeline_flag,
        "reason_for_delay" : this.batchDetails?.reason_for_delay,
        "revised_deadline" : this.batchDetails?.revised_deadline,
        "affected_deadline" : this.batchDetails?.revised_deadline ? "yes" : "no"
        })
        this.revised_deadline = new Date(this.batchDetails?.revised_deadline)
        this.loaderService.display(false);
        this.toastr.success("Batch stage fetched successfully", "Success");
      },
      (err) => {
        this.loaderService.display(false);
        for (let i in err.error.errors) {
          this.toastr.error(err.error.errors[i], "Error");
        }
      }
    );
  }

  revisedDatePickerHandler(value: any){
    this.revised_deadline = value;
    this.demoForm.patchValue({"revised_deadline" : value});
  }

  updateStage() {
    if(this.demoForm.invalid){
      return this.toastr.error("Please fill all the required fields.")
    }

    let formData = new FormData();

    formData.append(
      "timeline_flag",
      this.demoForm.value["timeline_flag"]
    );

    formData.append(
      "reason_for_delay",
      this.demoForm.value["reason_for_delay"]
    );

    formData.append(
      "revised_deadline",
      this.demoForm.value["revised_deadline"]
    );

    this.loaderService.display(true);

    this.adminService
      .updateVendorOrderItemBatch(this.batchDetails.id, formData)
      .subscribe(
        (res) => {
          this.loaderService.display(false);
          this.toastr.success("Batch timeline has been updated", "Success");
          this.close(true);
        },
        (err) => {
          this.loaderService.display(false);
          for (let i in err.error.errors) {
            this.toastr.error(err.error.errors[i], "Error");
          }
          this.close(false);
        }
      );
  }
}
